export default class {
  constructor (configurator) {
    this.configurator = configurator
    this.totalDiscount = 0
  }

  process () {
    this.totalDiscount = 0
    this.updateDiscounts()

    return this
  }

  updateDiscounts () {
    this.configurator.steps.forEach((step) => {
      if (step.options) {
        step.options.forEach((option) => {
          if (this.configurator.fencePriceApplied && typeof option.price_factor !== 'undefined') {
            if (option.price) {
              option.price.total = 0
              option.price.discounted = 0
            }
          } else if (typeof option.price_factor !== 'undefined') {
            if (option.selected) {
              const dimension = this.configurator.steps.find(s => s.type === 'dimension')
              if (typeof dimension !== 'undefined') {
                const height = dimension.height.value / 100
                const width = dimension.width.value / 100
                const panelPrice = this.specialPanelPrice(option, dimension)
                const total = panelPrice === null
                  ? height * width * Number(option.price_factor)
                  : panelPrice
                const discount = Number.parseFloat(option.discount || 0) / 100 * total
                const panels = panelPrice === null ? 1 : (Number.parseFloat(this.configurator.quantity) || 1)

                option.price.total = total
                option.price.discounted = total - discount
                this.totalDiscount += discount * panels
              }
            } else if (option.price) {
              option.price.total = 0
            }
          } else {
            this.updateOption(option)
          }
        })
      }
    })

    if (this.configurator.fencePriceApplied) {
      this.totalDiscount += (Number.parseFloat(this.configurator.fencePriceTotal) || 0) * this.selectedModelDiscountRate()
    }

    this.recalculateStepTotals()
    this.recalculateColorPrices()
    this.recalculateConfigTotal()

    this.configurator.price.old_price = Math.ceil(this.configurator.price.total)
    this.configurator.price.total -= this.totalDiscount
    const configDiscount = this.configurator.discount
    const configTotalPrice = this.configurator.price.total
    this.configurator.price.discounted = Math.ceil(configTotalPrice - (configTotalPrice / 100 * configDiscount))
  }

  recalculateStepTotals () {
    this.configurator.steps.forEach((step) => {
      if (step.price && step.options && ['simpleselect', 'conditional'].indexOf(step.type) !== -1) {
        step.price.options = step.options.reduce((price, option) => {
          return price + (option.price ? option.price.total || 0 : 0)
        }, 0)
        step.price.total = step.visible ? (step.price.self + step.price.options) : 0
      }
    })
  }

  recalculateColorPrices () {
    this.configurator.steps.filter((step) => step.type === 'color').forEach((step) => {
      if (!step.visible) {
        step.price.total = 0
        return
      }

      if (!step.colors || !step.price_on_steps) {
        return
      }

      const selectedColor = step.colors.find(color => color.selected)
      if (!selectedColor) {
        return
      }

      const totalRelatedPrice = this.configurator.steps
        .filter((filterStep) => step.price_on_steps.indexOf(filterStep.id) !== -1)
        .reduce((totalPrice, relatedStep) => totalPrice + (relatedStep.price ? relatedStep.price.total : 0), 0)

      step.price.total = (totalRelatedPrice / 100) * (selectedColor.special ? step.price_special : step.price)
    })
  }

  recalculateConfigTotal () {
    const quantity = Number.parseFloat(this.configurator.quantity) || 1
    const total = this.configurator.steps.reduce((price, step) => {
      return price + (step.price ? step.price.total || 0 : 0)
    }, 0)

    this.configurator.price.total = this.configurator.fencePriceApplied ? total : total * quantity
  }

  selectedModelDiscountRate () {
    const step = this.configurator.steps.find(item => item.model_step) ||
      this.configurator.steps.find(item => item.name === 'Muster')
    const option = step?.options?.find(item => item.selected)
    return Number.parseFloat(option?.discount || 0) / 100
  }

  specialPanelPrice (option, dimension) {
    const width = Number.parseInt(dimension.width.value, 10)
    const height = Number.parseInt(dimension.height.value, 10)
    const standart = Array.isArray(option.standart_dim)
      ? option.standart_dim.find(row => {
        return Number.parseInt(row?.width, 10) === width &&
          Number.parseInt(row?.height, 10) === height &&
          Number.parseFloat(row?.price) > 0
      })
      : null
    if (standart) {
      return null
    }
    const special = (Array.isArray(option.special_dim) ? option.special_dim : [])
      .find(row => this.specialCovers(row, width, height) && Number.parseFloat(row?.price) > 0)
    if (!special) {
      return null
    }
    const price = Number.parseFloat(special.price) || 0
    const markup = Number.parseFloat(option.markup) || 0
    const withMarkup = price + (price * markup / 100)
    const tax = 19 / 100
    return withMarkup + (withMarkup * tax)
  }

  specialCovers (row, width, height) {
    if (!row?.width || !row?.height || typeof row.width.from === 'undefined') {
      return false
    }
    const heightFrom = Number.parseInt(row.height.from, 10)
    const heightTo = Number.parseInt(row.height.to, 10)
    const widthFrom = Number.parseInt(row.width.from, 10)
    const widthTo = Number.parseInt(row.width.to, 10)
    const heightMatches = heightTo <= 0
      ? heightFrom <= height
      : heightFrom <= height && heightTo >= height
    return heightMatches && widthFrom <= width && widthTo >= width
  }

  updateOption (option) {
    if (option.price && option.discount) {
      const discount = Number.parseFloat(option.discount) / 100 * option.price.total
      option.price.discounted = option.price.total - discount
      this.totalDiscount += discount
    }
  }
}
